import classNames from "classnames";
import styles from "./HealthIndicator.module.scss";
import Tooltip from "../../ui/Tooltip/Tooltip";

function HealthIndicator({
  max,
  min,
  value,
}: {
  max?: number;
  min?: number;
  value: number;
}) {
  let healthy = true;
  let message = "";

  if (!max && !min) {
    return null;
  }

  if (max && !min) {
    healthy = value <= max;
    message = healthy
      ? `Under ${value} characters`
      : `Over ${value} characters`;
  }

  if (!max && min) {
    healthy = value >= min;
    message = healthy
      ? `Over ${value} characters`
      : `Under ${value} characters`;
  }

  if (max && min) {
    healthy = value >= min && value <= max;
    message = healthy
      ? `Within recommended range (${min}-${max})`
      : `${
          value > max ? max - value : min - value
        } characters to reach recommended range (${min}-${max})`;
  }

  return (
    <Tooltip content={message}>
      <div
        className={classNames(styles.indicator, {
          [styles.healthy]: healthy,
          [styles.unhealthy]: !healthy,
        })}
      />
    </Tooltip>
  );
}

export default HealthIndicator;
